import {
  Stack,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useState } from "react";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

// Field options (key and display label)
const OPTIONS = [
  { key: "basic", label: "Basic Details (excluding PLU Code)", disabled: true },
  { key: "ingredient", label: "Ingredients", disabled: true },
  { key: "alternate_UOM", label: "Alternative Units Mapping", disabled: false },
  { key: "chart_settings", label: "Chart Settings", disabled: false },
  { key: "how_to_prepare", label: "How to Prepare", disabled: false },
  { key: "stores", label: "Stores", disabled: false },
  { key: "cost_and_pricing", label: "Tips & Procedures", disabled: false },
  { key: "label", label: "Labels", disabled: false },
];

function RecipeCloneDialog({
  handleRecipeClone,
  state,
  onOpenRecipeCloneDialog,
  recipeClone,
}) {
  const allEnabledKeys = OPTIONS.filter((opt) => !opt.disabled).map(
    (opt) => opt.key
  );

  const [selectedItems, setSelectedItems] = useState([...allEnabledKeys]);
  const [includeAll, setIncludeAll] = useState(true);

  const handleToggleItem = (item) => {
    setSelectedItems((prev) => {
      const updated = prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item];
      setIncludeAll(updated.length === allEnabledKeys.length);
      return updated;
    });
  };

  const handleToggleAll = () => {
    if (includeAll) {
      setSelectedItems([]);
      setIncludeAll(false);
    } else {
      setSelectedItems([...allEnabledKeys]);
      setIncludeAll(true);
    }
  };

  const handleSave = () => {
    handleRecipeClone(selectedItems);
  };

  return (
    <Box display="flex" flexDirection="column">
      {/* Scrollable content */}
      <Box
        sx={{
          maxHeight: "60vh",
          px: "16px",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "&:hover": {
            "&::-webkit-scrollbar": {
              display: "initial",
            },
          },
        }}
      >
        <Typography fontSize="16px" mb={2}>
          Creating a clone of recipe {`“${state?.cloneRecipeName}”`}
        </Typography>

        <Stack spacing={1}>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeAll}
                onChange={handleToggleAll}
                indeterminate={
                  selectedItems.length > 0 &&
                  selectedItems.length < allEnabledKeys.length
                }
              />
            }
            label={
              <Typography fontSize={"16px"} fontWeight={500}>
                Include All
              </Typography>
            }
          />

          {OPTIONS.map(({ key, label, disabled }, index) => (
            <FormControlLabel
              key={key + index}
              control={
                <Checkbox
                  disabled={disabled}
                  checked={disabled || selectedItems.includes(key)}
                  onChange={() => handleToggleItem(key)}
                />
              }
              label={
                <Typography
                  sx={{ color: disabled ? "text.disabled" : "text.primary" }}
                  fontSize={"14px"}
                  fontWeight={400}
                >
                  {label}
                </Typography>
              }
            />
          ))}
        </Stack>
      </Box>

      <CustomDialogFooter
        disabled={recipeClone?.isPending}
        handleClose={() => onOpenRecipeCloneDialog(false)}
        onSubmit={handleSave}
      />
    </Box>
  );
}

export default RecipeCloneDialog;
